const translations = {
  "en": {
    "Ask Ed": "Ask Ed",
    "Close Chat to Brief": "Close Chat to Brief"
  },
  "zh-tw": {
    "Ask Ed": "問問 Ed",
    "Close Chat to Brief": "關閉對話並返回簡報"
  }
};

export default translations;
